/* Info component for the walkies Create page */
import React from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../styles/Callsheets.module.css";

const ImportWalks = () => {
  return (
    <div>
        <Row className="my-3">
        <Col md={{span: 10, offset: 1}}>
         <div className={`px-3 py-2 text-center ${styles.SubTitle6}`}>
          <p className={`${styles.Red} text-center`}>WALKIES INFO</p>
          <hr className={`mt-2 mb-0`}/>
          <p className={`pt-2`}>
          <span className={`${styles.Red}`}>*</span> Add and Update Walkie Channels here.
          </p>
          <p className={`pt-2`}>
          <span className={`${styles.Red}`}>*</span> They will be automatically added to all Callsheets 
          so as not to have to be repeatedly added to each one individually.
          </p>
          <hr className={`mt-2 mb-0`}/>
        </div>
        </Col>
      </Row>
    </div>
  )
}

export default ImportWalks